
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm0 16.085c-3.907 0-7.085-3.178-7.085-7.085S8.093 4.915 12 4.915 19.085 8.093 19.085 12 15.907 19.085 12 19.085z"}}),_c('path',{attrs:{"d":"M16.29 11.536H12.42V6.732a.721.721 0 00-.71-.732.721.721 0 00-.709.732v5.536c0 .404.318.732.71.732h4.58c.392 0 .71-.328.71-.732a.721.721 0 00-.71-.732z"}})])])
          )
        }
      }
    